/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import Text from "./Text";
import Flex from "./Flex";

const StyledNote = styled(Flex)`
  ${({ $variant }) => variantStyles[$variant]}
`;

const variantStyles = {
  default: css`
    &::before {
      display: block;
      width: 2px;
      flex-shrink: 0;
      border-radius: 4px;
      content: "";
      background: rgba(${({ theme }) => theme.colors.accent.rgba});
    }
  `,
  
  filled: css`
    padding: 0.5rem;
    border-radius: 0.5rem;
    background: rgba(${({ theme }) => theme.colors.accent.rgb}, 0.08);
  `,
};

const NoteIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding: 0.25rem;
`;

const NoteContent = styled.div`
  display: grid;
`;

const Note = ({ title, text, icon, variant = "default", children }) => {
  return (
    <StyledNote $variant={variant} $gap="0.5rem">
      {icon && <NoteIcon>{icon}</NoteIcon>}
      <NoteContent>
        {title && (
          <Text size="small" color="dark" weight="bold">
            {title}
          </Text>
        )}
        {text && (
          <Text size="small" color="dark">
            {text}
          </Text>
        )}
        {children}
      </NoteContent>
    </StyledNote>
  );
};

export default Note;
